// Mirrored in applications/platform-app/components/web-analytics — change both.
import React from 'react';
import { useDash } from '../context';
import { BreakdownCard, useBreakdown } from './shared';
import { MetricChart } from './OverviewTab';
import { Card, Empty, ErrorLine, Note, Td, Th, rowButton } from '../ui';
import { fmt, moneyCents, pct, valueLabel } from '../format';

const Campaigns: React.FC = () => {
  const d = useDash();
  const company = d.siteKind === 'company';
  const q = useBreakdown('campaign', 10);
  const rows = q.data?.rows || [];
  return (
    <Card title="Campaigns (UTM)">
      {q.error ? <ErrorLine message={q.error} /> : !rows.length ? <Empty /> : (
        <div className="overflow-x-auto">
          <table className="w-full border-collapse text-[13px]">
            <thead><tr><Th>Campaign / source</Th><Th num>Visits</Th><Th num>{company ? 'Sign-ups' : 'Orders'}</Th><Th num>{company ? 'Conv.' : 'Revenue'}</Th></tr></thead>
            <tbody>
              {rows.map((r) => {
                const click = d.rowFilter('campaign', r.value);
                return (
                  <tr key={r.value} {...rowButton(click, `Filter by campaign ${r.value}`)}>
                    <Td>{valueLabel('campaign', r.value)}</Td>
                    <Td num>{fmt(r.visits)}</Td>
                    <Td num>{fmt(company ? r.signups : r.orders)}</Td>
                    <Td num>{company ? pct(r.visits ? r.signups / r.visits : 0) : moneyCents(r.revenueCents)}</Td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      <Note>The "In-store QR" channel counts visits from QR codes printed on POS receipts and table tents.</Note>
    </Card>
  );
};

export const AcquisitionTab: React.FC = () => (
  <div>
    <MetricChart metric="visitors" title="Visitors" height={180} />
    <div className="grid gap-3.5 mt-3.5 grid-cols-1 md:grid-cols-2">
      <BreakdownCard title="Channels" dim="channel" viewAll />
      <BreakdownCard title="Sources" dim="source" limit={9} viewAll />
    </div>
    <div className="grid gap-3.5 mt-3.5 grid-cols-1 md:grid-cols-2">
      <BreakdownCard title="Referring websites" dim="referrer" viewAll />
      <Campaigns />
    </div>
  </div>
);

export default AcquisitionTab;
